import { render, staticRenderFns } from "./SumSection.vue?vue&type=template&id=76676f7c&scoped=true"
import script from "./SumSection.vue?vue&type=script&lang=js"
export * from "./SumSection.vue?vue&type=script&lang=js"
import style0 from "./SumSection.vue?vue&type=style&index=0&id=76676f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76676f7c",
  null
  
)

export default component.exports